import jwt from 'jsonwebtoken'
import {
    HIDDEN_DATA_SECRET,
    HIDDEN_DATA_TOKEN_EXP
} from '../constants'

export const unhideData = (hidden_data) => {
    const unhidden = jwt.verify(hidden_data, HIDDEN_DATA_SECRET, function(err, decoded) {
        if(err) {
            console.log("ERR: ", err)
            return null
        }
        return decoded
    })
    return unhidden
}

export const hideData = (payload) => {
    const hidden = jwt.sign(payload, HIDDEN_DATA_SECRET, {
        expiresIn: HIDDEN_DATA_TOKEN_EXP? HIDDEN_DATA_TOKEN_EXP : '7d'
    })
    return hidden
}

